import Swiper from 'swiper/bundle';

(function () {
    let simpleCardSwipers = [];

    function mobile() {
        return window.innerWidth < 768;
    }

    function transformToGrid(container) {
        const wrapper = container.querySelector('.swiper-wrapper');
        if (!wrapper) return;

        wrapper.classList.remove('swiper-wrapper');
        wrapper.classList.add('grid', 'md:flex', 'gap-[40px]');

        const slides = wrapper.querySelectorAll('.swiper-slide');
        slides.forEach((slide) => {
            slide.classList.remove('swiper-slide');
            slide.style.opacity = '1';

        });
    }

    function transformToSwiper(container) {
        const wrapper = container.querySelector('.component-simple-cards__wrapper > div');
        if (!wrapper) return;

        wrapper.classList.add('swiper-wrapper');
        wrapper.classList.remove('grid', 'md:flex', 'gap-[40px]');

        const cards = wrapper.querySelectorAll('.component-simple-cards__card');
        cards.forEach((card) => {
            card.classList.add('swiper-slide', 'h-auto');
        });
    }

    function initializeSimpleCardSwipers() {
        const simpleCardContainers = document.querySelectorAll('.component-simple-cards__swiper');

        if (simpleCardContainers.length === 0) return;

        simpleCardContainers.forEach((container) => {
            transformToSwiper(container);

            const simpleSwiperInstance = new Swiper(container, {
                loop: true,
                slidesPerView: 1.4,
                spaceBetween: 40,
                pagination: {
                    el: container.querySelector('.swiper-pagination'),
                    type: 'fraction',
                    clickable: true,
                },
                navigation: {
                    nextEl: container.querySelector('.swiper-button-next'),
                    prevEl: container.querySelector('.swiper-button-prev'),
                },
                breakpoints: {
                    768: {
                        slidesPerView: 4,
                        slidesPerGroup: 4,
                        loopAddBlankSlides: true,
                    },
                },
            });

            simpleCardSwipers.push(simpleSwiperInstance);
        });
    }

    function destroySimpleCardSwipers() {
        const simpleCardContainers = document.querySelectorAll('.component-simple-cards__wrapper');

        simpleCardSwipers.forEach((swiper) => swiper.destroy(true, true));
        simpleCardSwipers = [];

        simpleCardContainers.forEach((container) => {
            transformToGrid(container);
        });
    }

    function handleResize() {
        if (mobile()) {
            initializeSimpleCardSwipers();
        } else {
            destroySimpleCardSwipers();
        }
    }

    document.addEventListener('DOMContentLoaded', () => {
        if (mobile()) {
            initializeSimpleCardSwipers();
        } else {
            destroySimpleCardSwipers();
        }

        window.addEventListener('resize', handleResize);
    });

    window.simpleCardSwiper = {
        initialize: initializeSimpleCardSwipers,
        destroy:    destroySimpleCardSwipers,
    };
})();

/**
 * Component-Swiper Cards glue code
 * Works on the front-end and inside Gutenberg’s iframe preview
 *----
 */
(function () {
	/**
	 * We keep a simple array of live Swiper instances.
	 */
	const liveSwipers = [];

	/**
	 * init(root)
	 * ----------
	 * Creates Swipers for every `.component-swiper-cards__swiper`
	 * found *inside* the supplied `root` (defaults to whole document).
	 */
	function init(root = document) {
		root
			.querySelectorAll('.component-swiper-cards__swiper')
			.forEach((container) => {
				// Skip containers that already have a Swiper
				if (container.classList.contains('swiper-initialized')) return;

				// eslint-disable-next-line no-undef  ← Swiper comes from your bundle
				const swiper = new Swiper(container, {
					loop: true,
					slidesPerView: 1.4,
					spaceBetween: 40,
					pagination: {
						el: container.querySelector('.swiper-pagination'),
						type: 'fraction',
						clickable: true,
					},
					navigation: {
						nextEl: container.querySelector('.swiper-button-next'),
						prevEl: container.querySelector('.swiper-button-prev'),
					},
					breakpoints: {
						768: {
							slidesPerView: 4,
							slidesPerGroup: 4,
							loopAddBlankSlides: true,
						},
					},
				});

				// Remember this instance so we can destroy it later
				liveSwipers.push(swiper);
			});
	}

	/**
	 * destroy(root)
	 * -------------
	 * Destroys any Swiper whose `.el` lives *inside* `root`,
	 * then removes it from the `liveSwipers` array.
	 */
	function destroy(root = document) {
		liveSwipers.forEach((swiper, index) => {
			if (root.contains(swiper.el)) {
				swiper.destroy(true, true);
				liveSwipers.splice(index, 1); // remove from our list
			}
		});
	}

	/*
	 * Front-end: run once when the full page’s DOM is ready
	 */
	document.addEventListener('DOMContentLoaded', () => init());

	/*
	 * Gutenberg editor:
	 * ACF fires `render_block_preview` *inside the parent window*
	 * **every** time your block’s preview HTML is refreshed.
	 */
	if (typeof acf !== 'undefined' && acf.addAction) {
		acf.addAction(
			// Replace with your actual block name slug
			'render_block_preview/type=component-swiper-cards',
			/**
			 * @param {jQuery} $block   The root element that ACF just injected
			 */
			function ($block) {
				const iframeDoc = $block[0].ownerDocument;

				// Clean out any Swipers already living in that iframe
				destroy(iframeDoc);

				// Build fresh Swipers for the updated markup
				init(iframeDoc);
			}
		);
	}

	/*
	 * Expose functions globally for manual reinit or destroy if needed
	 * Example usage:
	 *   window.swiperCardSwiper.destroy();
	 *   window.swiperCardSwiper.init();
	 */
	window.swiperCardSwiper = {
		init,
		destroy,
	};
})();

/**
 * Component-Media Swiper glue code
 * Works on the front-end and inside Gutenberg’s iframe preview
 *----
 */
(function () {
	/**
	 * We keep a simple array of live Swiper instances.
	 * (WeakSet wouldn’t let us iterate easily.)
	 */
	const liveSwipers = [];

	/**
	 * init(root)
	 * ----------
	 * Creates Swipers for every `.component-component-media__media`
	 * found *inside* the supplied `root` (defaults to whole document).
	 */
	function init(root = document) {
		root
			.querySelectorAll('.component-component-media__media')
			.forEach((container) => {
				// Skip containers that already have a Swiper
				if (container.classList.contains('swiper-initialized')) return;

				// eslint-disable-next-line no-undef  ← Swiper comes from your bundle
				const swiper = new Swiper(container, {
					loop: true,
					slidesPerView: 1,
					spaceBetween: 0,
					pagination: {
						el: container.querySelector('.swiper-pagination'),
						type: 'fraction',
						clickable: true,
					},
					navigation: {
						nextEl: container.querySelector('.swiper-button-next'),
						prevEl: container.querySelector('.swiper-button-prev'),
					},
				});

				// Remember this instance so we can destroy it later
				liveSwipers.push(swiper);
			});
	}

	/**
	 * destroy(root)
	 * -------------
	 * Destroys any Swiper whose `.el` lives *inside* `root`,
	 * then removes it from the `liveSwipers` array.
	 */
	function destroy(root = document) {
		liveSwipers.forEach((swiper, index) => {
			if (root.contains(swiper.el)) {
				swiper.destroy(true, true);
				liveSwipers.splice(index, 1); // remove from our list
			}
		});
	}

	/*
	 * Front-end: run once when the full page’s DOM is ready
	 */
	document.addEventListener('DOMContentLoaded', () => init());

	/*
	 * Gutenberg editor:
	 * ACF fires `render_block_preview` *inside the parent window*
	 * **every** time your block’s preview HTML is refreshed.
	 */
	if (typeof acf !== 'undefined' && acf.addAction) {
		acf.addAction(
			// Limit the hook to *this* block type only
			'render_block_preview/type=component-component-media',
			/**
			 * @param {jQuery} $block   The root element that ACF just injected
			 */
			function ($block) {
				/**
				 * `$block[0]` is the <section> in the iframe.
				 * `ownerDocument` lets us step *into* that iframe’s document.
				 */
				const iframeDoc = $block[0].ownerDocument;

				// Clean out any Swipers already living in that iframe
				destroy(iframeDoc);

				// Build fresh Swipers for the updated markup
				init(iframeDoc);
			}
		);
	}
})();

(function () {
    let outerMegaCarouselSwiper = null;
    let innerMegaCarouselSwipers = [];
    let outerHeadings = [];

    function initializeMegaCarouselSwipers() {
        const outerContainer = document.querySelector('.component-mega-carousel__outer');

        if (!outerContainer) return;

        const headings = [...outerContainer.querySelectorAll('.swiper-slide')]
        .filter(slide => !slide.classList.contains('swiper-slide-duplicate'))
        .map(slide => slide.dataset.heading || '');

        // Init parent Swiper if present
        if (outerContainer) {
            outerMegaCarouselSwiper = new Swiper(outerContainer, {
                loop: true,
                slidesPerView: 1,
                pagination: {
                    el: outerContainer.querySelector('.swiper-outer-pagination'),
                    type: 'fraction',
                    clickable: true,
                },
                navigation: {
                    nextEl: outerContainer.querySelector('.swiper-outer-button-next'),
                    prevEl: outerContainer.querySelector('.swiper-outer-button-prev'),
                },
                on: {
                    init: function () {
                        // Extract ONLY real slides (ignore duplicates)
                        outerHeadings = [...this.slides]
                            .filter(slide => !slide.classList.contains('swiper-slide-duplicate'))
                            .map(slide => slide.dataset.heading || '');
        
                        updateOuterNavLabels(this);
                    },
                    slideChange: function () {
                        updateOuterNavLabels(this);
                    }
                }
            });
        }

        function updateOuterNavLabels(swiper) {
            if (!outerHeadings || outerHeadings.length === 0) return;
        
            const total = outerHeadings.length;
            const currentIndex = swiper.realIndex;
        
            const prevIndex = (currentIndex - 1 + total) % total;
            const nextIndex = (currentIndex + 1) % total;
        
            const prevLabel = document.querySelector('.swiper-outer-prev-label');
            const nextLabel = document.querySelector('.swiper-outer-next-label');
        
            if (prevLabel) prevLabel.textContent = outerHeadings[prevIndex] || '';
            if (nextLabel) nextLabel.textContent = outerHeadings[nextIndex] || '';
        }

        // Init all inner Swipers
        const innerContainers = document.querySelectorAll('.component-mega-carousel__slider');

        innerContainers.forEach((container) => {
            const swiperInstance = new Swiper(container, {
                loop: true,
                slidesPerView: 1,
                navigation: {
                    nextEl: container.querySelector('.swiper-inner-button-next'),
                    prevEl: container.querySelector('.swiper-inner-button-prev'),
                },
            });

            innerMegaCarouselSwipers.push(swiperInstance);
        });
    }

    function destroyMegaCarouselSwipers() {
        if (outerMegaCarouselSwiper) {
            outerMegaCarouselSwiper.destroy(true, true);
            outerMegaCarouselSwiper = null;
        }

        innerMegaCarouselSwipers.forEach((swiper) => swiper.destroy(true, true));
        innerMegaCarouselSwipers = [];
    }

    document.addEventListener('DOMContentLoaded', initializeMegaCarouselSwipers);

    window.megaCarouselSwiper = {
        initialize: initializeMegaCarouselSwipers,
        destroy: destroyMegaCarouselSwipers
    };
})();

/**
 * Component-Swiper-Container Swiper glue code
 * Works on the front-end and inside Gutenberg’s iframe preview (somewhat heh!)
 *
 */
(function () {
	const liveSwipers = [];

	// Get max horizontal gap from container edge to screen edge
	function getContainerEdgeGap(root = document) {
		let maxGap = 0;

		const components = root.querySelectorAll('.component-swiper-container');

		components.forEach(component => {
			const container = component.closest('.block-container__content');
			if (container) {
				const rect = container.getBoundingClientRect();
				const leftGap = rect.left;
				const rightGap = window.innerWidth - rect.right;
				maxGap = Math.max(maxGap, leftGap, rightGap);
			}
		});

		return maxGap;
	}

    function init(root = document) {
        const spaceGap = getContainerEdgeGap(root) + 48;
        // const spaceGap = 48;

        root.querySelectorAll('.component-swiper-container__swiper').forEach(container => {
            if (container.classList.contains('swiper-initialized')) return;

            const labelEl = container.querySelector('.swiper-slide-label');

            const slideHeadings = Array.from(container.querySelectorAll('.component-swiper-slide')).map(slide =>
                slide.getAttribute('data-slide-heading') || ''
            );

            const swiper = new Swiper(container, {
                loop: false,
                slidesPerView: 1,
                spaceBetween: spaceGap || 0,
                navigation: {
                    nextEl: container.querySelector('.swiper-button-next-swiper'),
                    prevEl: container.querySelector('.swiper-button-prev-swiper'),
                },
                on: {
                    init: function () {
                        if (labelEl) {
                            labelEl.textContent = slideHeadings[this.realIndex] || '';
                        }
                    },
                    slideChange: function () {
                        if (labelEl) {
                            labelEl.textContent = slideHeadings[this.realIndex] || '';
                        }
                    }
                }
            });

            liveSwipers.push(swiper);
        });
    }

	function destroy(root = document) {
		liveSwipers.forEach((swiper, index) => {
			if (root.contains(swiper.el)) {
				swiper.destroy(true, true);
				liveSwipers.splice(index, 1);
			}
		});
	}

	// Run on DOM ready
	document.addEventListener('DOMContentLoaded', () => init());

	// Re-init on resize.
	window.addEventListener('resize', debounce(() => {
		destroy();
		init();
	}, 200));

	function debounce(func, wait) {
		let timeout;
		return function () {
			clearTimeout(timeout);
			timeout = setTimeout(func, wait);
		};
	}
})();

